/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const rpcService = /* GraphQL */ `
  mutation RpcService($input: ServiceInput!) {
    rpcService(input: $input) {
      message
      success
      output
    }
  }
`;
export const joynEngine = /* GraphQL */ `
  mutation JoynEngine($input: AWSJSON!) {
    joynEngine(input: $input) {
      message
      success
      output
    }
  }
`;
export const registerUpdateInAsset = /* GraphQL */ `
  mutation RegisterUpdateInAsset($areaId: String!, $assetId: String!) {
    registerUpdateInAsset(areaId: $areaId, assetId: $assetId) {
      areaId
      asset {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
    }
  }
`;
export const registerUpdateInUser = /* GraphQL */ `
  mutation RegisterUpdateInUser($areaId: String!, $userId: String!, $vendorId: String!) {
    registerUpdateInUser(areaId: $areaId, userId: $userId, vendorId: $vendorId) {
      areaId
      user {
        id
        xid
        sourceSystem
        tenantId
        fieldId
        userName
        firstName
        lastName
        email
        phone
        deviceId
        startLatitude
        startLongitude
        endLatitude
        endLongitude
        currentLatitude
        currentLongitude
        shiftStartTime
        shiftEndTime
        startStopId
        endStopId
        contractHourlyRate
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        activityStatus
        hitch {
          hitchStartDate
          hitchPattern {
            hitchWorkDays
            hitchOffDays
            sortOrder
          }
        }
        teams {
          userId
          teamId
          isDeleted
          isTeamLead
          isTeamMember
        }
        roles {
          userId
          roleId
          isDeleted
        }
        contacts
        defaultContact
        offDays
        onDays
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        isDeleted
        timeZone
        aws_ds
        locationUpdatedOn
        deviceMetadata
        vendorId
        aclQualifiedId
        contractInfoId
        businessTitle
        joyn2Roles
        signatureObject {
          bucket
          key
          region
          fileName
        }
        approver
        iscreatedFromFSM
        cognitoUserName
        mobileSettings
        isEquipmentResource
        operatorId
        accessCreatedBy
        shareCreatedWith
        allowReassignmentOnMobile
      }
      vendorId
    }
  }
`;
export const registerUpdateInUserTask = /* GraphQL */ `
  mutation RegisterUpdateInUserTask($userId: String!, $taskId: String!, $vendorId: String!) {
    registerUpdateInUserTask(userId: $userId, taskId: $taskId, vendorId: $vendorId) {
      userId
      taskId
      vendorId
    }
  }
`;
export const registerUpdateInFieldTask = /* GraphQL */ `
  mutation RegisterUpdateInFieldTask($fieldId: String!, $task: AWSJSON!, $vendorId: String!) {
    registerUpdateInFieldTask(fieldId: $fieldId, task: $task, vendorId: $vendorId) {
      fieldId
      task {
        approvedBy
        approvedOn
        asset {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        assetId
        assignee
        assigneeIds {
          assigneeId
          sequence
          isDeleted
          isAccepted
          acceptedOn
          vendorId
          operatorId
        }
        assignedOn
        attachments {
          bucket
          key
          region
          fileName
        }
        completedOn
        createdOn
        createdBy
        data
        duration
        endTime
        eventSource
        isRecurring
        fieldId
        id
        isHardAssignee
        isPlanned
        recurrenceInactive
        priority
        schedule {
          rrule
          startDate
          endDate
          recurrencePattern
          type
          displayUptoDays
          allowPileups
          overwriteEditedOccurrences
        }
        sourceRecurringTaskId
        originalRecurrenceDate
        deletedForRecurrenceDates
        isHardStartTime
        startTime
        status
        taskType {
          id
          duration
          priority
          score
          increment
          name
          schema
          teamId
          tenantId
          fieldId
          isParent
          autoApprove
          workflowVersions {
            version
            workflowSteps {
              workflowStepId
              taskTypeId
              dependsOn
              immediateNextTo
              sameAssigneeAs
              sameStartTimeAs
              formSectionId
              preferredLocationTypeId
              priorityTemplate
              assigneeIds
              sameLocationAs
              autoResolveDependsOn
            }
          }
          publishedVersion
          createdOn
          createdBy
          modifiedOn
          modifiedBy
          isDeleted
          needAcceptance
          enforceTimeSpent
          enforceComment
          enableReassign
          enableAutoAssign
          hasFormAttributes
          isLinkable
          certificates {
            id
            name
            isExpirable
            expiryDate
          }
          skillLevel {
            id
            name
            value
          }
          resolveOnArchive
          partsPicklist
          formSchemaId
          approvalMatrix
          disableCreateOnMobile
          disableAssignOnMobile
          disablePriorityOnMobile
          disableWorkOrderOnMobile
          disableDateOnMobile
          disableAssetOnMobile
          resolveOnGeofence
          excludeByRoutingEngine
          disablePrioritySelectionOnMobile
          disableEditingResolvedOnMobile
          taskTypeCode
          generateMultiple
          globalAttributes
          reminder {
            enableReminder
            reminderTime {
              days
              hours
              minutes
            }
          }
          attachmentIds
          instructionIds
          notification {
            notificationProfile
            notificationConfig {
              actionType
              userTypeForEmail
              userTypeForPushNotification
              sectionsToIncludeInEmail
            }
          }
          notificationProfile
          actionsEnabled
          userType
          fullManualMode
          singleActiveTask
          mandatoryWatcherGroups
          priorityTemplate
          priorityAlias
          rt_id
          needEquipment
          mandatoryAssignee
          autoAssignFirstChildToCreator
          triggerTasksUsingRules
          groups {
            id
            name
          }
          watcherGroupConfig {
            entityId
            entityPicklistWatcherGroupMappingId
            entityType
          }
          generateMultipleLabelName
          isDynamicParentChild
          rollupGlobalAttributes
          allowAssetLevelsInfo
          allowTaskCreationWithResolvedStatus
          autoResolveFirstTask
          defaultLocationTask
          allowedTeamsAsWatchers
        }
        taskTypeId
        tenantId
        parentTaskId
        workflowVersion
        workflowStepId
        modifiedOn
        modifiedBy
        dependsOn
        immediateNextTo
        sameAssigneeAs
        sameStartTimeAs
        sameLocationAs
        isDeleted
        delayMinutes
        resolvedBy
        resolvedOn
        linkedTaskIds
        template
        approvalStatus
        watcherIds
        parts {
          picklistId
          picklistOptionId
          quantity
        }
        formSchemaId
        formSectionId
        globalAttributes
        approvalInfo
        approverIds
        isApprovalWorkflow
        requestorIds
        onlyAllowManualScoreUpdate
        rejectedIds {
          id
          rejectedOn
        }
        scheduled
        taskNumber
        isTaskCopied
        watcherGroupIds
        timeToNextPriority
        isTaskLocked
        draftState
        readingId
        rulesEvaluated
        triggeredSourceTaskId
        generateMultiple
        copyGenerateMultipleAssignee
        nightShiftStartTime
        assetLevelsInfo
        nextRecurrenceDate
        prevRecurrenceDate
        statusAudit
        priorityScore
        score
        increment
      }
      vendorId
    }
  }
`;
export const registerUpdateInFieldUsersLocation = /* GraphQL */ `
  mutation RegisterUpdateInFieldUsersLocation($fieldId: String!, $usersLocation: AWSJSON!) {
    registerUpdateInFieldUsersLocation(fieldId: $fieldId, usersLocation: $usersLocation) {
      fieldId
      usersLocation
    }
  }
`;
export const registerUpdateInUsersNotification = /* GraphQL */ `
  mutation RegisterUpdateInUsersNotification($userId: String!, $usersNotification: AWSJSON!) {
    registerUpdateInUsersNotification(userId: $userId, usersNotification: $usersNotification) {
      userId
      usersNotification
    }
  }
`;
export const registerUpdateInFieldUsersUpdate = /* GraphQL */ `
  mutation RegisterUpdateInFieldUsersUpdate($fieldId: String!, $usersInfo: AWSJSON!) {
    registerUpdateInFieldUsersUpdate(fieldId: $fieldId, usersInfo: $usersInfo) {
      fieldId
      usersInfo
    }
  }
`;
export const registerUpdateInAreaTask = /* GraphQL */ `
  mutation RegisterUpdateInAreaTask($areaId: String!, $task: AWSJSON!, $vendorId: String!) {
    registerUpdateInAreaTask(areaId: $areaId, task: $task, vendorId: $vendorId) {
      areaId
      task {
        approvedBy
        approvedOn
        asset {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        assetId
        assignee
        assigneeIds {
          assigneeId
          sequence
          isDeleted
          isAccepted
          acceptedOn
          vendorId
          operatorId
        }
        assignedOn
        attachments {
          bucket
          key
          region
          fileName
        }
        completedOn
        createdOn
        createdBy
        data
        duration
        endTime
        eventSource
        isRecurring
        fieldId
        id
        isHardAssignee
        isPlanned
        recurrenceInactive
        priority
        schedule {
          rrule
          startDate
          endDate
          recurrencePattern
          type
          displayUptoDays
          allowPileups
          overwriteEditedOccurrences
        }
        sourceRecurringTaskId
        originalRecurrenceDate
        deletedForRecurrenceDates
        isHardStartTime
        startTime
        status
        taskType {
          id
          duration
          priority
          score
          increment
          name
          schema
          teamId
          tenantId
          fieldId
          isParent
          autoApprove
          workflowVersions {
            version
            workflowSteps {
              workflowStepId
              taskTypeId
              dependsOn
              immediateNextTo
              sameAssigneeAs
              sameStartTimeAs
              formSectionId
              preferredLocationTypeId
              priorityTemplate
              assigneeIds
              sameLocationAs
              autoResolveDependsOn
            }
          }
          publishedVersion
          createdOn
          createdBy
          modifiedOn
          modifiedBy
          isDeleted
          needAcceptance
          enforceTimeSpent
          enforceComment
          enableReassign
          enableAutoAssign
          hasFormAttributes
          isLinkable
          certificates {
            id
            name
            isExpirable
            expiryDate
          }
          skillLevel {
            id
            name
            value
          }
          resolveOnArchive
          partsPicklist
          formSchemaId
          approvalMatrix
          disableCreateOnMobile
          disableAssignOnMobile
          disablePriorityOnMobile
          disableWorkOrderOnMobile
          disableDateOnMobile
          disableAssetOnMobile
          resolveOnGeofence
          excludeByRoutingEngine
          disablePrioritySelectionOnMobile
          disableEditingResolvedOnMobile
          taskTypeCode
          generateMultiple
          globalAttributes
          reminder {
            enableReminder
            reminderTime {
              days
              hours
              minutes
            }
          }
          attachmentIds
          instructionIds
          notification {
            notificationProfile
            notificationConfig {
              actionType
              userTypeForEmail
              userTypeForPushNotification
              sectionsToIncludeInEmail
            }
          }
          notificationProfile
          actionsEnabled
          userType
          fullManualMode
          singleActiveTask
          mandatoryWatcherGroups
          priorityTemplate
          priorityAlias
          rt_id
          needEquipment
          mandatoryAssignee
          autoAssignFirstChildToCreator
          triggerTasksUsingRules
          groups {
            id
            name
          }
          watcherGroupConfig {
            entityId
            entityPicklistWatcherGroupMappingId
            entityType
          }
          generateMultipleLabelName
          isDynamicParentChild
          rollupGlobalAttributes
          allowAssetLevelsInfo
          allowTaskCreationWithResolvedStatus
          autoResolveFirstTask
          defaultLocationTask
          allowedTeamsAsWatchers
        }
        taskTypeId
        tenantId
        parentTaskId
        workflowVersion
        workflowStepId
        modifiedOn
        modifiedBy
        dependsOn
        immediateNextTo
        sameAssigneeAs
        sameStartTimeAs
        sameLocationAs
        isDeleted
        delayMinutes
        resolvedBy
        resolvedOn
        linkedTaskIds
        template
        approvalStatus
        watcherIds
        parts {
          picklistId
          picklistOptionId
          quantity
        }
        formSchemaId
        formSectionId
        globalAttributes
        approvalInfo
        approverIds
        isApprovalWorkflow
        requestorIds
        onlyAllowManualScoreUpdate
        rejectedIds {
          id
          rejectedOn
        }
        scheduled
        taskNumber
        isTaskCopied
        watcherGroupIds
        timeToNextPriority
        isTaskLocked
        draftState
        readingId
        rulesEvaluated
        triggeredSourceTaskId
        generateMultiple
        copyGenerateMultipleAssignee
        nightShiftStartTime
        assetLevelsInfo
        nextRecurrenceDate
        prevRecurrenceDate
        statusAudit
        priorityScore
        score
        increment
      }
      vendorId
    }
  }
`;
export const registerUpdateInAreaFeed = /* GraphQL */ `
  mutation RegisterUpdateInAreaFeed($areaId: String!, $feed: AWSJSON!, $vendorId: String!) {
    registerUpdateInAreaFeed(areaId: $areaId, feed: $feed, vendorId: $vendorId) {
      areaId
      feed {
        data
        fieldId
        id
        tenantId
        userId
        areaIds
        createdOn
        createdBy
        modifiedBy
        modifiedOn
        isDeleted
      }
      vendorId
    }
  }
`;
export const registerUpdateInRequestId = /* GraphQL */ `
  mutation RegisterUpdateInRequestId($requestId: ID!, $message: String, $success: Boolean) {
    registerUpdateInRequestId(requestId: $requestId, message: $message, success: $success) {
      requestId
      success
      message
    }
  }
`;
export const createAsset = /* GraphQL */ `
  mutation CreateAsset($input: CreateAssetInput!) {
    createAsset(input: $input) {
      id
      tenantId
      fieldId
      xid
      fdgxid
      cxid
      sourceSystem
      name
      type
      subType
      areas {
        areaId
        isDeleted
      }
      teams {
        teamId
        resources {
          userId
          resourceLevel
          isDeleted
        }
        isDeleted
      }
      routes
      fdgRouteId
      fdgRouteIds
      fdgObjectId
      stopId
      stop {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      latitude
      longitude
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      aws_ds
      isDeleted
      areaType
      areaDefinition {
        version
        criteria {
          attributeName
          values
        }
      }
      customAttributes
      bulkStopGroupName
      producingMethodId
      productType
      tankStrappingID
      attachments {
        bucket
        key
        region
        fileName
      }
      watchers
      contacts
      preferredLocations
      geofence
      additionalStopIds
      hierarchy
    }
  }
`;
export const createComment = /* GraphQL */ `
  mutation CreateComment($input: CreateCommentInput!) {
    createComment(input: $input) {
      assets
      attachments {
        bucket
        key
        region
        fileName
      }
      comment
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      fieldId
      id
      taskId
      assetId
      tenantId
      users
      isDeleted
      autoGenerated
    }
  }
`;
export const createDistanceMatrix = /* GraphQL */ `
  mutation CreateDistanceMatrix($input: CreateDistanceMatrixInput!) {
    createDistanceMatrix(input: $input) {
      id
      distance
      duration
      fieldId
      startGeoLocationId
      endGeoLocationId
      startStopId
      endStopId
      tenantId
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      isDeleted
    }
  }
`;
export const createFeed = /* GraphQL */ `
  mutation CreateFeed($input: CreateFeedInput!) {
    createFeed(input: $input) {
      data
      fieldId
      id
      tenantId
      userId
      areaIds
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      isDeleted
    }
  }
`;
export const createSettings = /* GraphQL */ `
  mutation CreateSettings($input: CreateSettingsInput!) {
    createSettings(input: $input) {
      id
      admin
      common
      app
      settings
      mapTilerSettings
      runEngineSettings
      automateDailyRunSettings
      featureFlags
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      created_at
      created_by
      updated_at
      updated_by
      tenantAuthCache
      fdgsssidCache
    }
  }
`;
export const createTask = /* GraphQL */ `
  mutation CreateTask($input: CreateTaskInput!) {
    createTask(input: $input) {
      approvedBy
      approvedOn
      asset {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      assetId
      assignee
      assigneeIds {
        assigneeId
        sequence
        isDeleted
        isAccepted
        acceptedOn
        vendorId
        operatorId
      }
      assignedOn
      attachments {
        bucket
        key
        region
        fileName
      }
      completedOn
      createdOn
      createdBy
      data
      duration
      endTime
      eventSource
      isRecurring
      fieldId
      id
      isHardAssignee
      isPlanned
      recurrenceInactive
      priority
      schedule {
        rrule
        startDate
        endDate
        recurrencePattern
        type
        displayUptoDays
        allowPileups
        overwriteEditedOccurrences
      }
      sourceRecurringTaskId
      originalRecurrenceDate
      deletedForRecurrenceDates
      isHardStartTime
      startTime
      status
      taskType {
        id
        duration
        priority
        score
        increment
        name
        schema
        teamId
        tenantId
        fieldId
        isParent
        autoApprove
        workflowVersions {
          version
          workflowSteps {
            workflowStepId
            taskTypeId
            dependsOn
            immediateNextTo
            sameAssigneeAs
            sameStartTimeAs
            formSectionId
            preferredLocationTypeId
            priorityTemplate
            assigneeIds
            sameLocationAs
            autoResolveDependsOn
          }
        }
        publishedVersion
        createdOn
        createdBy
        modifiedOn
        modifiedBy
        isDeleted
        needAcceptance
        enforceTimeSpent
        enforceComment
        enableReassign
        enableAutoAssign
        hasFormAttributes
        isLinkable
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        resolveOnArchive
        partsPicklist
        formSchemaId
        approvalMatrix
        disableCreateOnMobile
        disableAssignOnMobile
        disablePriorityOnMobile
        disableWorkOrderOnMobile
        disableDateOnMobile
        disableAssetOnMobile
        resolveOnGeofence
        excludeByRoutingEngine
        disablePrioritySelectionOnMobile
        disableEditingResolvedOnMobile
        taskTypeCode
        generateMultiple
        globalAttributes
        reminder {
          enableReminder
          reminderTime {
            days
            hours
            minutes
          }
        }
        attachmentIds
        instructionIds
        notification {
          notificationProfile
          notificationConfig {
            actionType
            userTypeForEmail
            userTypeForPushNotification
            sectionsToIncludeInEmail
          }
        }
        notificationProfile
        actionsEnabled
        userType
        fullManualMode
        singleActiveTask
        mandatoryWatcherGroups
        priorityTemplate
        priorityAlias
        rt_id
        needEquipment
        mandatoryAssignee
        autoAssignFirstChildToCreator
        triggerTasksUsingRules
        groups {
          id
          name
        }
        watcherGroupConfig {
          entityId
          entityPicklistWatcherGroupMappingId
          entityType
        }
        generateMultipleLabelName
        isDynamicParentChild
        rollupGlobalAttributes
        allowAssetLevelsInfo
        allowTaskCreationWithResolvedStatus
        autoResolveFirstTask
        defaultLocationTask
        allowedTeamsAsWatchers
      }
      taskTypeId
      tenantId
      parentTaskId
      workflowVersion
      workflowStepId
      modifiedOn
      modifiedBy
      dependsOn
      immediateNextTo
      sameAssigneeAs
      sameStartTimeAs
      sameLocationAs
      isDeleted
      delayMinutes
      resolvedBy
      resolvedOn
      linkedTaskIds
      template
      approvalStatus
      watcherIds
      parts {
        picklistId
        picklistOptionId
        quantity
      }
      formSchemaId
      formSectionId
      globalAttributes
      approvalInfo
      approverIds
      isApprovalWorkflow
      requestorIds
      onlyAllowManualScoreUpdate
      rejectedIds {
        id
        rejectedOn
      }
      scheduled
      taskNumber
      isTaskCopied
      watcherGroupIds
      timeToNextPriority
      isTaskLocked
      draftState
      readingId
      rulesEvaluated
      triggeredSourceTaskId
      generateMultiple
      copyGenerateMultipleAssignee
      nightShiftStartTime
      assetLevelsInfo
      nextRecurrenceDate
      prevRecurrenceDate
      statusAudit
      priorityScore
      score
      increment
    }
  }
`;
export const createTaskType = /* GraphQL */ `
  mutation CreateTaskType($input: CreateTaskTypeInput!) {
    createTaskType(input: $input) {
      id
      duration
      priority
      score
      increment
      name
      schema
      teamId
      tenantId
      fieldId
      isParent
      autoApprove
      workflowVersions {
        version
        workflowSteps {
          workflowStepId
          taskTypeId
          dependsOn
          immediateNextTo
          sameAssigneeAs
          sameStartTimeAs
          formSectionId
          preferredLocationTypeId
          priorityTemplate
          assigneeIds
          sameLocationAs
          autoResolveDependsOn
        }
      }
      publishedVersion
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      isDeleted
      needAcceptance
      enforceTimeSpent
      enforceComment
      enableReassign
      enableAutoAssign
      hasFormAttributes
      isLinkable
      certificates {
        id
        name
        isExpirable
        expiryDate
      }
      skillLevel {
        id
        name
        value
      }
      resolveOnArchive
      partsPicklist
      formSchemaId
      approvalMatrix
      disableCreateOnMobile
      disableAssignOnMobile
      disablePriorityOnMobile
      disableWorkOrderOnMobile
      disableDateOnMobile
      filterDraftTasksOnMobile
      disableAssetOnMobile
      resolveOnGeofence
      excludeByRoutingEngine
      disablePrioritySelectionOnMobile
      disableEditingResolvedOnMobile
      taskTypeCode
      generateMultiple
      globalAttributes
      reminder {
        enableReminder
        reminderTime {
          days
          hours
          minutes
        }
      }
      attachmentIds
      instructionIds
      notification {
        notificationProfile
        notificationConfig {
          actionType
          userTypeForEmail
          userTypeForPushNotification
          sectionsToIncludeInEmail
        }
      }
      notificationProfile
      actionsEnabled
      userType
      fullManualMode
      singleActiveTask
      mandatoryWatcherGroups
      priorityTemplate
      priorityAlias
      rt_id
      needEquipment
      mandatoryAssignee
      autoAssignFirstChildToCreator
      triggerTasksUsingRules
      groups {
        id
        name
      }
      watcherGroupConfig {
        entityId
        entityPicklistWatcherGroupMappingId
        entityType
      }
      generateMultipleLabelName
      isDynamicParentChild
      rollupGlobalAttributes
      allowAssetLevelsInfo
      allowTaskCreationWithResolvedStatus
      autoResolveFirstTask
      defaultLocationTask
      allowedTeamsAsWatchers
    }
  }
`;
export const createTenant = /* GraphQL */ `
  mutation CreateTenant($input: CreateTenantInput!) {
    createTenant(input: $input) {
      id
      name
      created_at
      created_by
      updated_at
      updated_by
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      id
      xid
      sourceSystem
      tenantId
      fieldId
      userName
      firstName
      lastName
      email
      phone
      deviceId
      startLatitude
      startLongitude
      endLatitude
      endLongitude
      currentLatitude
      currentLongitude
      shiftStartTime
      shiftEndTime
      startStopId
      endStopId
      contractHourlyRate
      certificates {
        id
        name
        isExpirable
        expiryDate
      }
      skillLevel {
        id
        name
        value
      }
      activityStatus
      hitch {
        hitchStartDate
        hitchPattern {
          hitchWorkDays
          hitchOffDays
          sortOrder
        }
      }
      teams {
        userId
        teamId
        isDeleted
        isTeamLead
        isTeamMember
      }
      roles {
        userId
        roleId
        isDeleted
      }
      contacts
      defaultContact
      offDays
      onDays
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      isDeleted
      timeZone
      aws_ds
      locationUpdatedOn
      deviceMetadata
      vendorId
      aclQualifiedId
      contractInfoId
      businessTitle
      joyn2Roles
      signatureObject {
        bucket
        key
        region
        fileName
      }
      approver
      iscreatedFromFSM
      cognitoUserName
      mobileSettings
      isEquipmentResource
      operatorId
      accessCreatedBy
      shareCreatedWith
      allowReassignmentOnMobile
    }
  }
`;
export const createTeam = /* GraphQL */ `
  mutation CreateTeam($input: CreateTeamInput!) {
    createTeam(input: $input) {
      id
      name
      tenantId
      fieldId
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      isDeleted
      aws_ds
      allowedTaskTypeCreateGroups {
        id
        name
      }
    }
  }
`;
export const deleteAsset = /* GraphQL */ `
  mutation DeleteAsset($input: DeleteAssetInput!) {
    deleteAsset(input: $input) {
      id
      tenantId
      fieldId
      xid
      fdgxid
      cxid
      sourceSystem
      name
      type
      subType
      areas {
        areaId
        isDeleted
      }
      teams {
        teamId
        resources {
          userId
          resourceLevel
          isDeleted
        }
        isDeleted
      }
      routes
      fdgRouteId
      fdgRouteIds
      fdgObjectId
      stopId
      stop {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      latitude
      longitude
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      aws_ds
      isDeleted
      areaType
      areaDefinition {
        version
        criteria {
          attributeName
          values
        }
      }
      customAttributes
      bulkStopGroupName
      producingMethodId
      productType
      tankStrappingID
      attachments {
        bucket
        key
        region
        fileName
      }
      watchers
      contacts
      preferredLocations
      geofence
      additionalStopIds
      hierarchy
    }
  }
`;
export const deleteComment = /* GraphQL */ `
  mutation DeleteComment($input: DeleteCommentInput!) {
    deleteComment(input: $input) {
      assets
      attachments {
        bucket
        key
        region
        fileName
      }
      comment
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      fieldId
      id
      taskId
      assetId
      tenantId
      users
      isDeleted
      autoGenerated
    }
  }
`;
export const deleteDistanceMatrix = /* GraphQL */ `
  mutation DeleteDistanceMatrix($input: DeleteDistanceMatrixInput!) {
    deleteDistanceMatrix(input: $input) {
      id
      distance
      duration
      fieldId
      startGeoLocationId
      endGeoLocationId
      startStopId
      endStopId
      tenantId
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      isDeleted
    }
  }
`;
export const deleteFeed = /* GraphQL */ `
  mutation DeleteFeed($input: DeleteFeedInput!) {
    deleteFeed(input: $input) {
      data
      fieldId
      id
      tenantId
      userId
      areaIds
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      isDeleted
    }
  }
`;
export const deleteSettings = /* GraphQL */ `
  mutation DeleteSettings($input: DeleteSettingsInput!) {
    deleteSettings(input: $input) {
      id
      admin
      common
      app
      settings
      mapTilerSettings
      runEngineSettings
      automateDailyRunSettings
      featureFlags
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      created_at
      created_by
      updated_at
      updated_by
      tenantAuthCache
      fdgsssidCache
    }
  }
`;
export const deleteTask = /* GraphQL */ `
  mutation DeleteTask($input: DeleteTaskInput!) {
    deleteTask(input: $input) {
      approvedBy
      approvedOn
      asset {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      assetId
      assignee
      assigneeIds {
        assigneeId
        sequence
        isDeleted
        isAccepted
        acceptedOn
        vendorId
        operatorId
      }
      assignedOn
      attachments {
        bucket
        key
        region
        fileName
      }
      completedOn
      createdOn
      createdBy
      data
      duration
      endTime
      eventSource
      isRecurring
      fieldId
      id
      isHardAssignee
      isPlanned
      recurrenceInactive
      priority
      schedule {
        rrule
        startDate
        endDate
        recurrencePattern
        type
        displayUptoDays
        allowPileups
        overwriteEditedOccurrences
      }
      sourceRecurringTaskId
      originalRecurrenceDate
      deletedForRecurrenceDates
      isHardStartTime
      startTime
      status
      taskType {
        id
        duration
        priority
        score
        increment
        name
        schema
        teamId
        tenantId
        fieldId
        isParent
        autoApprove
        workflowVersions {
          version
          workflowSteps {
            workflowStepId
            taskTypeId
            dependsOn
            immediateNextTo
            sameAssigneeAs
            sameStartTimeAs
            formSectionId
            preferredLocationTypeId
            priorityTemplate
            assigneeIds
            sameLocationAs
            autoResolveDependsOn
          }
        }
        publishedVersion
        createdOn
        createdBy
        modifiedOn
        modifiedBy
        isDeleted
        needAcceptance
        enforceTimeSpent
        enforceComment
        enableReassign
        enableAutoAssign
        hasFormAttributes
        isLinkable
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        resolveOnArchive
        partsPicklist
        formSchemaId
        approvalMatrix
        disableCreateOnMobile
        disableAssignOnMobile
        disablePriorityOnMobile
        disableWorkOrderOnMobile
        disableDateOnMobile
        disableAssetOnMobile
        resolveOnGeofence
        excludeByRoutingEngine
        disablePrioritySelectionOnMobile
        disableEditingResolvedOnMobile
        taskTypeCode
        generateMultiple
        globalAttributes
        reminder {
          enableReminder
          reminderTime {
            days
            hours
            minutes
          }
        }
        attachmentIds
        instructionIds
        notification {
          notificationProfile
          notificationConfig {
            actionType
            userTypeForEmail
            userTypeForPushNotification
            sectionsToIncludeInEmail
          }
        }
        notificationProfile
        actionsEnabled
        userType
        fullManualMode
        singleActiveTask
        mandatoryWatcherGroups
        priorityTemplate
        priorityAlias
        rt_id
        needEquipment
        mandatoryAssignee
        autoAssignFirstChildToCreator
        triggerTasksUsingRules
        groups {
          id
          name
        }
        watcherGroupConfig {
          entityId
          entityPicklistWatcherGroupMappingId
          entityType
        }
        generateMultipleLabelName
        isDynamicParentChild
        rollupGlobalAttributes
        allowAssetLevelsInfo
        allowTaskCreationWithResolvedStatus
        autoResolveFirstTask
        defaultLocationTask
        allowedTeamsAsWatchers
      }
      taskTypeId
      tenantId
      parentTaskId
      workflowVersion
      workflowStepId
      modifiedOn
      modifiedBy
      dependsOn
      immediateNextTo
      sameAssigneeAs
      sameStartTimeAs
      sameLocationAs
      isDeleted
      delayMinutes
      resolvedBy
      resolvedOn
      linkedTaskIds
      template
      approvalStatus
      watcherIds
      parts {
        picklistId
        picklistOptionId
        quantity
      }
      formSchemaId
      formSectionId
      globalAttributes
      approvalInfo
      approverIds
      isApprovalWorkflow
      requestorIds
      onlyAllowManualScoreUpdate
      rejectedIds {
        id
        rejectedOn
      }
      scheduled
      taskNumber
      isTaskCopied
      watcherGroupIds
      timeToNextPriority
      isTaskLocked
      draftState
      readingId
      rulesEvaluated
      triggeredSourceTaskId
      generateMultiple
      copyGenerateMultipleAssignee
      nightShiftStartTime
      assetLevelsInfo
      nextRecurrenceDate
      prevRecurrenceDate
      statusAudit
      priorityScore
      score
      increment
    }
  }
`;
export const deleteTaskType = /* GraphQL */ `
  mutation DeleteTaskType($input: DeleteTaskTypeInput!) {
    deleteTaskType(input: $input) {
      id
      duration
      priority
      score
      increment
      name
      schema
      teamId
      tenantId
      fieldId
      isParent
      autoApprove
      workflowVersions {
        version
        workflowSteps {
          workflowStepId
          taskTypeId
          dependsOn
          immediateNextTo
          sameAssigneeAs
          sameStartTimeAs
          formSectionId
          preferredLocationTypeId
          priorityTemplate
          assigneeIds
          sameLocationAs
          autoResolveDependsOn
        }
      }
      publishedVersion
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      isDeleted
      needAcceptance
      enforceTimeSpent
      enforceComment
      enableReassign
      enableAutoAssign
      hasFormAttributes
      isLinkable
      certificates {
        id
        name
        isExpirable
        expiryDate
      }
      skillLevel {
        id
        name
        value
      }
      resolveOnArchive
      partsPicklist
      formSchemaId
      approvalMatrix
      disableCreateOnMobile
      disableAssignOnMobile
      disablePriorityOnMobile
      disableWorkOrderOnMobile
      disableDateOnMobile
      filterDraftTasksOnMobile
      disableAssetOnMobile
      resolveOnGeofence
      excludeByRoutingEngine
      disablePrioritySelectionOnMobile
      disableEditingResolvedOnMobile
      taskTypeCode
      generateMultiple
      globalAttributes
      reminder {
        enableReminder
        reminderTime {
          days
          hours
          minutes
        }
      }
      attachmentIds
      instructionIds
      notification {
        notificationProfile
        notificationConfig {
          actionType
          userTypeForEmail
          userTypeForPushNotification
          sectionsToIncludeInEmail
        }
      }
      notificationProfile
      actionsEnabled
      userType
      fullManualMode
      singleActiveTask
      mandatoryWatcherGroups
      priorityTemplate
      priorityAlias
      rt_id
      needEquipment
      mandatoryAssignee
      autoAssignFirstChildToCreator
      triggerTasksUsingRules
      groups {
        id
        name
      }
      watcherGroupConfig {
        entityId
        entityPicklistWatcherGroupMappingId
        entityType
      }
      generateMultipleLabelName
      isDynamicParentChild
      rollupGlobalAttributes
      allowAssetLevelsInfo
      allowTaskCreationWithResolvedStatus
      autoResolveFirstTask
      defaultLocationTask
      allowedTeamsAsWatchers
    }
  }
`;
export const deleteTenant = /* GraphQL */ `
  mutation DeleteTenant($input: DeleteTenantInput!) {
    deleteTenant(input: $input) {
      id
      name
      created_at
      created_by
      updated_at
      updated_by
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser($input: DeleteUserInput!) {
    deleteUser(input: $input) {
      id
      xid
      sourceSystem
      tenantId
      fieldId
      userName
      firstName
      lastName
      email
      phone
      deviceId
      startLatitude
      startLongitude
      endLatitude
      endLongitude
      currentLatitude
      currentLongitude
      shiftStartTime
      shiftEndTime
      startStopId
      endStopId
      contractHourlyRate
      certificates {
        id
        name
        isExpirable
        expiryDate
      }
      skillLevel {
        id
        name
        value
      }
      activityStatus
      hitch {
        hitchStartDate
        hitchPattern {
          hitchWorkDays
          hitchOffDays
          sortOrder
        }
      }
      teams {
        userId
        teamId
        isDeleted
        isTeamLead
        isTeamMember
      }
      roles {
        userId
        roleId
        isDeleted
      }
      contacts
      defaultContact
      offDays
      onDays
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      isDeleted
      timeZone
      aws_ds
      locationUpdatedOn
      deviceMetadata
      vendorId
      aclQualifiedId
      contractInfoId
      businessTitle
      joyn2Roles
      signatureObject {
        bucket
        key
        region
        fileName
      }
      approver
      iscreatedFromFSM
      cognitoUserName
      mobileSettings
      isEquipmentResource
      operatorId
      accessCreatedBy
      shareCreatedWith
      allowReassignmentOnMobile
    }
  }
`;
export const deleteTeam = /* GraphQL */ `
  mutation DeleteTeam($input: DeleteTeamInput!) {
    deleteTeam(input: $input) {
      id
      name
      tenantId
      fieldId
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      isDeleted
      aws_ds
      allowedTaskTypeCreateGroups {
        id
        name
      }
    }
  }
`;
export const updateAsset = /* GraphQL */ `
  mutation UpdateAsset($input: UpdateAssetInput!) {
    updateAsset(input: $input) {
      id
      tenantId
      fieldId
      xid
      fdgxid
      cxid
      sourceSystem
      name
      type
      subType
      areas {
        areaId
        isDeleted
      }
      teams {
        teamId
        resources {
          userId
          resourceLevel
          isDeleted
        }
        isDeleted
      }
      routes
      fdgRouteId
      fdgRouteIds
      fdgObjectId
      stopId
      stop {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      latitude
      longitude
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      aws_ds
      isDeleted
      areaType
      areaDefinition {
        version
        criteria {
          attributeName
          values
        }
      }
      customAttributes
      bulkStopGroupName
      producingMethodId
      productType
      tankStrappingID
      attachments {
        bucket
        key
        region
        fileName
      }
      watchers
      contacts
      preferredLocations
      geofence
      additionalStopIds
      hierarchy
    }
  }
`;
export const updateComment = /* GraphQL */ `
  mutation UpdateComment($input: UpdateCommentInput!) {
    updateComment(input: $input) {
      assets
      attachments {
        bucket
        key
        region
        fileName
      }
      comment
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      fieldId
      id
      taskId
      assetId
      tenantId
      users
      isDeleted
      autoGenerated
    }
  }
`;
export const updateDistanceMatrix = /* GraphQL */ `
  mutation UpdateDistanceMatrix($input: UpdateDistanceMatrixInput!) {
    updateDistanceMatrix(input: $input) {
      id
      distance
      duration
      fieldId
      startGeoLocationId
      endGeoLocationId
      startStopId
      endStopId
      tenantId
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      isDeleted
    }
  }
`;
export const updateFeed = /* GraphQL */ `
  mutation UpdateFeed($input: UpdateFeedInput!) {
    updateFeed(input: $input) {
      data
      fieldId
      id
      tenantId
      userId
      areaIds
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      isDeleted
    }
  }
`;
export const updateSettings = /* GraphQL */ `
  mutation UpdateSettings($input: UpdateSettingsInput!) {
    updateSettings(input: $input) {
      id
      admin
      common
      app
      settings
      mapTilerSettings
      runEngineSettings
      automateDailyRunSettings
      featureFlags
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      created_at
      created_by
      updated_at
      updated_by
      tenantAuthCache
      fdgsssidCache
    }
  }
`;
export const updateTask = /* GraphQL */ `
  mutation UpdateTask($input: UpdateTaskInput!) {
    updateTask(input: $input) {
      approvedBy
      approvedOn
      asset {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      assetId
      assignee
      assigneeIds {
        assigneeId
        sequence
        isDeleted
        isAccepted
        acceptedOn
        vendorId
        operatorId
      }
      assignedOn
      attachments {
        bucket
        key
        region
        fileName
      }
      completedOn
      createdOn
      createdBy
      data
      duration
      endTime
      eventSource
      isRecurring
      fieldId
      id
      isHardAssignee
      isPlanned
      recurrenceInactive
      priority
      schedule {
        rrule
        startDate
        endDate
        recurrencePattern
        type
        displayUptoDays
        allowPileups
        overwriteEditedOccurrences
      }
      sourceRecurringTaskId
      originalRecurrenceDate
      deletedForRecurrenceDates
      isHardStartTime
      startTime
      status
      taskType {
        id
        duration
        priority
        score
        increment
        name
        schema
        teamId
        tenantId
        fieldId
        isParent
        autoApprove
        workflowVersions {
          version
          workflowSteps {
            workflowStepId
            taskTypeId
            dependsOn
            immediateNextTo
            sameAssigneeAs
            sameStartTimeAs
            formSectionId
            preferredLocationTypeId
            priorityTemplate
            assigneeIds
            sameLocationAs
            autoResolveDependsOn
          }
        }
        publishedVersion
        createdOn
        createdBy
        modifiedOn
        modifiedBy
        isDeleted
        needAcceptance
        enforceTimeSpent
        enforceComment
        enableReassign
        enableAutoAssign
        hasFormAttributes
        isLinkable
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        resolveOnArchive
        partsPicklist
        formSchemaId
        approvalMatrix
        disableCreateOnMobile
        disableAssignOnMobile
        disablePriorityOnMobile
        disableWorkOrderOnMobile
        disableDateOnMobile
        disableAssetOnMobile
        resolveOnGeofence
        excludeByRoutingEngine
        disablePrioritySelectionOnMobile
        disableEditingResolvedOnMobile
        taskTypeCode
        generateMultiple
        globalAttributes
        reminder {
          enableReminder
          reminderTime {
            days
            hours
            minutes
          }
        }
        attachmentIds
        instructionIds
        notification {
          notificationProfile
          notificationConfig {
            actionType
            userTypeForEmail
            userTypeForPushNotification
            sectionsToIncludeInEmail
          }
        }
        notificationProfile
        actionsEnabled
        userType
        fullManualMode
        singleActiveTask
        mandatoryWatcherGroups
        priorityTemplate
        priorityAlias
        rt_id
        needEquipment
        mandatoryAssignee
        autoAssignFirstChildToCreator
        triggerTasksUsingRules
        groups {
          id
          name
        }
        watcherGroupConfig {
          entityId
          entityPicklistWatcherGroupMappingId
          entityType
        }
        generateMultipleLabelName
        isDynamicParentChild
        rollupGlobalAttributes
        allowAssetLevelsInfo
        allowTaskCreationWithResolvedStatus
        autoResolveFirstTask
        defaultLocationTask
        allowedTeamsAsWatchers
      }
      taskTypeId
      tenantId
      parentTaskId
      workflowVersion
      workflowStepId
      modifiedOn
      modifiedBy
      dependsOn
      immediateNextTo
      sameAssigneeAs
      sameStartTimeAs
      sameLocationAs
      isDeleted
      delayMinutes
      resolvedBy
      resolvedOn
      linkedTaskIds
      template
      approvalStatus
      watcherIds
      parts {
        picklistId
        picklistOptionId
        quantity
      }
      formSchemaId
      formSectionId
      globalAttributes
      approvalInfo
      approverIds
      isApprovalWorkflow
      requestorIds
      onlyAllowManualScoreUpdate
      rejectedIds {
        id
        rejectedOn
      }
      scheduled
      taskNumber
      isTaskCopied
      watcherGroupIds
      timeToNextPriority
      isTaskLocked
      draftState
      readingId
      rulesEvaluated
      triggeredSourceTaskId
      generateMultiple
      copyGenerateMultipleAssignee
      nightShiftStartTime
      assetLevelsInfo
      nextRecurrenceDate
      prevRecurrenceDate
      statusAudit
      priorityScore
      score
      increment
    }
  }
`;
export const updateTaskType = /* GraphQL */ `
  mutation UpdateTaskType($input: UpdateTaskTypeInput!) {
    updateTaskType(input: $input) {
      id
      duration
      priority
      score
      increment
      name
      schema
      teamId
      tenantId
      fieldId
      isParent
      autoApprove
      workflowVersions {
        version
        workflowSteps {
          workflowStepId
          taskTypeId
          dependsOn
          immediateNextTo
          sameAssigneeAs
          sameStartTimeAs
          formSectionId
          preferredLocationTypeId
          priorityTemplate
          assigneeIds
          sameLocationAs
          autoResolveDependsOn
        }
      }
      publishedVersion
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      isDeleted
      needAcceptance
      enforceTimeSpent
      enforceComment
      enableReassign
      enableAutoAssign
      hasFormAttributes
      isLinkable
      certificates {
        id
        name
        isExpirable
        expiryDate
      }
      skillLevel {
        id
        name
        value
      }
      resolveOnArchive
      partsPicklist
      formSchemaId
      approvalMatrix
      disableCreateOnMobile
      disableAssignOnMobile
      disablePriorityOnMobile
      disableWorkOrderOnMobile
      disableDateOnMobile
      filterDraftTasksOnMobile
      disableAssetOnMobile
      resolveOnGeofence
      excludeByRoutingEngine
      disablePrioritySelectionOnMobile
      disableEditingResolvedOnMobile
      taskTypeCode
      generateMultiple
      globalAttributes
      reminder {
        enableReminder
        reminderTime {
          days
          hours
          minutes
        }
      }
      attachmentIds
      instructionIds
      notification {
        notificationProfile
        notificationConfig {
          actionType
          userTypeForEmail
          userTypeForPushNotification
          sectionsToIncludeInEmail
        }
      }
      notificationProfile
      actionsEnabled
      userType
      fullManualMode
      singleActiveTask
      mandatoryWatcherGroups
      priorityTemplate
      priorityAlias
      rt_id
      needEquipment
      mandatoryAssignee
      autoAssignFirstChildToCreator
      triggerTasksUsingRules
      groups {
        id
        name
      }
      watcherGroupConfig {
        entityId
        entityPicklistWatcherGroupMappingId
        entityType
      }
      generateMultipleLabelName
      isDynamicParentChild
      rollupGlobalAttributes
      allowAssetLevelsInfo
      allowTaskCreationWithResolvedStatus
      autoResolveFirstTask
      defaultLocationTask
      allowedTeamsAsWatchers
    }
  }
`;
export const updateTenant = /* GraphQL */ `
  mutation UpdateTenant($input: UpdateTenantInput!) {
    updateTenant(input: $input) {
      id
      name
      created_at
      created_by
      updated_at
      updated_by
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      xid
      sourceSystem
      tenantId
      fieldId
      userName
      firstName
      lastName
      email
      phone
      deviceId
      startLatitude
      startLongitude
      endLatitude
      endLongitude
      currentLatitude
      currentLongitude
      shiftStartTime
      shiftEndTime
      startStopId
      endStopId
      contractHourlyRate
      certificates {
        id
        name
        isExpirable
        expiryDate
      }
      skillLevel {
        id
        name
        value
      }
      activityStatus
      hitch {
        hitchStartDate
        hitchPattern {
          hitchWorkDays
          hitchOffDays
          sortOrder
        }
      }
      teams {
        userId
        teamId
        isDeleted
        isTeamLead
        isTeamMember
      }
      roles {
        userId
        roleId
        isDeleted
      }
      contacts
      defaultContact
      offDays
      onDays
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      isDeleted
      timeZone
      aws_ds
      locationUpdatedOn
      deviceMetadata
      vendorId
      aclQualifiedId
      contractInfoId
      businessTitle
      joyn2Roles
      signatureObject {
        bucket
        key
        region
        fileName
      }
      approver
      iscreatedFromFSM
      cognitoUserName
      mobileSettings
      isEquipmentResource
      operatorId
      accessCreatedBy
      shareCreatedWith
      allowReassignmentOnMobile
    }
  }
`;
export const updateTeam = /* GraphQL */ `
  mutation UpdateTeam($input: UpdateTeamInput!) {
    updateTeam(input: $input) {
      id
      name
      tenantId
      fieldId
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      isDeleted
      aws_ds
      allowedTaskTypeCreateGroups {
        id
        name
      }
    }
  }
`;
export const createEntityAttribute = /* GraphQL */ `
  mutation CreateEntityAttribute($input: CreateEntityAttributeInput!) {
    createEntityAttribute(input: $input) {
      id
      tenantId
      xid
      sourceSystem
      attributeDisplayName
      assetType
      attributeType
      attributeName
      isDeleted
    }
  }
`;
export const updateEntityAttribute = /* GraphQL */ `
  mutation UpdateEntityAttribute($input: UpdateEntityAttributeInput!) {
    updateEntityAttribute(input: $input) {
      id
      tenantId
      xid
      sourceSystem
      attributeDisplayName
      assetType
      attributeType
      attributeName
      isDeleted
    }
  }
`;
export const deleteEntityAttribute = /* GraphQL */ `
  mutation DeleteEntityAttribute($input: DeleteEntityAttributeInput!) {
    deleteEntityAttribute(input: $input) {
      id
      tenantId
      xid
      sourceSystem
      attributeDisplayName
      assetType
      attributeType
      attributeName
      isDeleted
    }
  }
`;
export const createPicklist = /* GraphQL */ `
  mutation CreatePicklist($input: CreatePicklistInput!) {
    createPicklist(input: $input) {
      createdBy
      createdOn
      desc
      id
      modifiedBy
      modifiedOn
      name
      options
      parentId
      tenantId
      xid
      isCustomizable
      displayName
    }
  }
`;
export const deletePicklist = /* GraphQL */ `
  mutation DeletePicklist($input: DeletePicklistInput!) {
    deletePicklist(input: $input) {
      createdBy
      createdOn
      desc
      id
      modifiedBy
      modifiedOn
      name
      options
      parentId
      tenantId
      xid
      isCustomizable
      displayName
    }
  }
`;
export const updatePicklist = /* GraphQL */ `
  mutation UpdatePicklist($input: UpdatePicklistInput!) {
    updatePicklist(input: $input) {
      createdBy
      createdOn
      desc
      id
      modifiedBy
      modifiedOn
      name
      options
      parentId
      tenantId
      xid
      isCustomizable
      displayName
    }
  }
`;
export const createRole = /* GraphQL */ `
  mutation CreateRole($input: CreateRoleInput!) {
    createRole(input: $input) {
      id
      name
      access
      createdBy
      createdOn
      modifiedBy
      modifiedOn
    }
  }
`;
export const updateRole = /* GraphQL */ `
  mutation UpdateRole($input: UpdateRoleInput!) {
    updateRole(input: $input) {
      id
      name
      access
      createdBy
      createdOn
      modifiedBy
      modifiedOn
    }
  }
`;
export const deleteRole = /* GraphQL */ `
  mutation DeleteRole($input: DeleteRoleInput!) {
    deleteRole(input: $input) {
      id
      name
      access
      createdBy
      createdOn
      modifiedBy
      modifiedOn
    }
  }
`;
export const createFactor = /* GraphQL */ `
  mutation CreateFactor($input: CreateFactorInput!) {
    createFactor(input: $input) {
      id
      name
      displayName
      description
      isActive
      hasMatrix
      isDeleted
      excludedTaskTypes
      excludedTaskTypeGroups
      type
      fieldId
      stopLevel {
        formula
        globalAttributes
        categoryMatrix
      }
      assetLevel {
        formula
        globalAttributes
        categoryMatrix
      }
      scoreMatrix {
        formula
        factors
        priorityMatrix
      }
      tenantId
      createdBy
      modifiedBy
      createdOn
      modifiedOn
    }
  }
`;
export const updateFactor = /* GraphQL */ `
  mutation UpdateFactor($input: UpdateFactorInput!) {
    updateFactor(input: $input) {
      id
      name
      displayName
      description
      isActive
      hasMatrix
      isDeleted
      excludedTaskTypes
      excludedTaskTypeGroups
      type
      fieldId
      stopLevel {
        formula
        globalAttributes
        categoryMatrix
      }
      assetLevel {
        formula
        globalAttributes
        categoryMatrix
      }
      scoreMatrix {
        formula
        factors
        priorityMatrix
      }
      tenantId
      createdBy
      modifiedBy
      createdOn
      modifiedOn
    }
  }
`;

export const deleteFactor = /* GraphQL */ `
  mutation DeleteFactor($input: DeleteFactorInput!) {
    deleteFactor(input: $input) {
      id
    }
  }
`;
